import { AxiosPromise } from 'axios'

import ClientSDK from '../App/ClientSDK'

import { IAPIPreference, IPreference } from './interface/IPreference'
import { reversePreferenceTransformer } from './Store/preferenceResponseTransformer'

export const fetchPreferences = (
  establishmentUuid: string,
): AxiosPromise<IAPIPreference> => {
  return ClientSDK.instance().get(
    'preferences?establishment_uuid=' + establishmentUuid,
  )
}

// TODO check if boolean
export const setPreferenceCall = (
  name: string,
  value: any,
  establishmentUuid: string | undefined,
): AxiosPromise => {
  const transformData = reversePreferenceTransformer(value)
  return ClientSDK.instance().post(
    'preferences?establishment_uuid=' + establishmentUuid,
    { name, value, transformData },
  )
}
